<script>
import Swal from "sweetalert2";
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import CKEditor from "@ckeditor/ckeditor5-vue";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import vue2Dropzone from "vue2-dropzone";
import BannerApi from "@/services/banner-api";
import AnnouncementsApi from "@/services/announcements-api";
import ItemsApi from "@/services/items-api";
import i18n from "../../../i18n";
import {Priviliges} from "../../../privileges";
import {Dimensions} from "./bannerDimensions";
import {ImageDimensions} from "./announcementDimensions";

export default {
  page: {
    title: "Bannières",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,ckeditor: CKEditor.component,vueDropzone: vue2Dropzone
  },

  data() {
    return {
      bannerList: [],
      newsTypeList: [{name:i18n.t('parameters.highlight'), value: 0 }, {name:i18n.t('parameters.news'), value: 1},{name:i18n.t('parameters.promotion'), value: 2}],

      selectedAnnouncment:{id:null,title:'',tag:'',type:'',date:'',description:'',titleEn:'' , tagEn:'' , descriptionEn:''},
      editor: ClassicEditor,
      pagemodelMain: { currentPage: 1, perPage: 10, totalRows: 0 },
      isAnnouncmentsTableBusy:false,
      showBannerImageModal: false,
      showAllBanner: false,
      showAnnouncementsModal:false,
      isLinkImage:false,
      imageModalUrl: "",
      bannerModalUrl: "",
      maxFileSize: null,
      selectedBanner: {
        id: null,
        name: null,
        generatedName: null,
        position: 1,
      },

      formData: null,
      selectedImage: null,
      endOfFindBanner: false,
      isBannerTableBusy: false,
      dropzoneOptions: {
              url: "/",
              thumbnailWidth: 150,
              // maxFileSizeInMB: 1,
              addRemoveLinks: true,
              autoProcessQueue:false,
            },
      formError:false,
      announcementsList:[],
      selectedType:null,
      privileges:"",
      isAdmin:false,
      hasAnnouncementsAccess:false,
      hasBannersAccess:false,
      uploadingBannerStarting:false,

      dimensions : Dimensions,
      imageDimensions:ImageDimensions,
      activeTab:0,
      saveAnouncementStarting:false,
    };
  },

  mounted() {
      if(sessionStorage.getItem("privileges")!=null){
        this.privileges=sessionStorage.getItem("privileges")
        this.isAdmin=this.privileges.includes(Priviliges[0]["Admin_Role"] )
        this.hasAnnouncementsAccess=this.privileges.includes(Priviliges[0]["Announcements_Management"] )
        this.hasBannersAccess=this.privileges.includes(Priviliges[0]["Advertising_Banners_Management"] )
    }
    if(this.isAdmin || this.hasBannersAccess ){
      this.findBanner();
    }
    this.getMaxFileSize();
    ClassicEditor.defaultConfig = {
      toolbar: {
        items: [
          'heading',
          '|',
          'bold',
          'italic',
          '|',
          'bulletedList',
          'numberedList',
          '|',
          'insertTable',
          '|',
          'undo',
          'redo'
        ]
      },
      image: {
        toolbar: [
          'imageStyle:full',
          'imageStyle:side',
          '|',
          'imageTextAlternative'
        ]
      },
      table: {
        contentToolbar: [ 'tableColumn', 'tableRow', 'mergeTableCells' ]
      },
      language: 'en'
    }
  },

  methods: {
    getMaxFileSize() {
      ItemsApi.getMaxFileSize().then((size) => {
        this.maxFileSize = size;
      });
    },

    findBanner() {
      this.isBannerTableBusy = true;
      BannerApi.getBanners()
        .then((result) => {
          if(result){
            this.bannerList = result;
          }
          
        })
        .finally(() => {
          this.isBannerTableBusy = false;
        });
    },

    uploadBanner() {
      const fd = new FormData();
      fd.append("file", this.selectedBanner, this.selectedBanner.name);
      BannerApi.uploadBanner(fd).then((res) => {
        if (res) {
          this.findBanner();
          this.uploadingBannerStarting=false;
        }
      }).finally(
        ()=>{
           this.uploadingBannerStarting=false;
        }
      );
    },

    onBannerUpload(event) {
      this.uploadingBannerStarting=true;
      this.selectedBanner = event.target.files[0];
      this.uploadBanner();
    },

    removeBanner(banner) {
      Swal.fire({
        title: i18n.t('parameters.swal.removeBanner.title'),
        html: banner.title,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#f46a6a",
        cancelButtonColor: "#34c38f",
        cancelButtonText: i18n.t('parameters.swal.removeBanner.cancelButtonText'),
        confirmButtonText: i18n.t('parameters.swal.removeBanner.confirmButtonText'),
      }).then((result) => {
        if (result.value) {
          BannerApi.removeBanner(banner.id).then(() => {
            this.findBanner();
          });
        }
      });
    },

    savePosition(data) {
      BannerApi.savePosition(data).then((result) => {
        if (result) {
          this.findBanner();
        }
      });
    },

    getType(type){
      if(type==null){
        return;
      }
      switch(type) {
        case 0: return {name:i18n.t('parameters.promotion'), value: 0 };
        case 1: return {name:i18n.t('parameters.news'), value: 1};
        case 2: return {name: i18n.t('parameters.highlight'), value: 2};
        default: return 'supplier';
      }
    },

    editAnnouncement(data){
      this.selectedAnnouncment.id=data.id
      this.selectedAnnouncment.title=data.title
      this.selectedAnnouncment.date=data.date
      this.selectedType=this.getType(data.type)
      this.selectedAnnouncment.tag=data.tag
      this.selectedAnnouncment.description=data.description
      this.selectedAnnouncment.titleEn=data.titleEn
      this.selectedAnnouncment.tagEn=data.tagEn
      this.selectedAnnouncment.descriptionEn=data.descriptionEn
    },

    clearAnnounccement(){
      this.selectedAnnouncment.id=null
      this.selectedAnnouncment.title=""
      this.selectedAnnouncment.date=""
      this.selectedAnnouncment.type=""
      this.selectedAnnouncment.tag=""
      this.selectedAnnouncment.description=""
      this.selectedAnnouncment.titleEn=""
      this.selectedAnnouncment.tagEn=""
      this.selectedAnnouncment.descriptionEn=""
      this.selectedType=null
      this.selectedImage=null
    },

    saveAnnouncment(){
      this.formError=false
      if(!this.selectedAnnouncment.id){
        this.selectedImage=this.$refs.myVueDropzone.getAcceptedFiles()[0]
      }
      if(!this.selectedAnnouncment.date || !this.selectedAnnouncment.title || !this.selectedAnnouncment.titleEn  || !this.selectedType!=0  || (!this.selectedAnnouncment.id && !this.selectedImage)) {        
        this.formError=true
        return;
      }
      Swal.fire({
        title: this.selectedAnnouncment.id ? i18n.t('parameters.swal.saveAnnouncment.title1') : i18n.t('parameters.swal.saveAnnouncment.title2'),
        html:this.selectedAnnouncment.title,
        icon: "info",
        showCancelButton: true,
        confirmButtonColor: "#f46a6a",
        cancelButtonColor: "#34c38f",
        cancelButtonText: i18n.t('parameters.swal.saveAnnouncment.cancelButtonText'),
        confirmButtonText: i18n.t('parameters.swal.saveAnnouncment.confirmButtonText'),
    }).then(result=>{
      if(result.value){
        this.saveAnouncementStarting=true
        if(!this.selectedAnnouncment.id){
          const fd = new FormData();
          fd.set('file',this.selectedImage)
          fd.set('title',this.selectedAnnouncment.title)
          fd.set('titleEn',this.selectedAnnouncment.titleEn)
          fd.set('date',this.selectedAnnouncment.date)
          fd.set('type', !this.selectedType ? null : this.selectedType.value)
          fd.set('tag',this.selectedAnnouncment.tag)
          fd.set('tagEn',this.selectedAnnouncment.tagEn)
          fd.set('description',this.selectedAnnouncment.description)
          fd.set('descriptionEn',this.selectedAnnouncment.descriptionEn)
          AnnouncementsApi.saveAnnouncment(fd).then(
          (result)=>{
            if(result){
              this.getAnnouncments()
              this.selectedAnnouncment={id:null,title:'',tag:'',type:'',date:'',description:'',titleEn:'' , tagEn:'' , descriptionEn:''};
              this.showAnnouncementsModal=false
              this.selectedImage=null
              this.formError=false
              this.selectedType=null
              this.saveAnouncementStarting=false
            }
          }
          )
        }else{
          this.selectedAnnouncment.type = !this.selectedType ? null : this.selectedType.value
          AnnouncementsApi.editAnnouncement(this.selectedAnnouncment).then(
            (result)=>{
              if(result){
                this.getAnnouncments()
                this.selectedAnnouncment={id:null,title:'',tag:'',type:'',date:'',description:'',titleEn:'' , tagEn:'' , descriptionEn:''};
                this.showAnnouncementsModal=false
                this.selectedImage=null
                this.formError=false
                this.selectedType=null
                this.saveAnouncementStarting=false
              }
            }
          )
        }
      }}
        )
    },

    getAnnouncments() {
      this.isAnnouncmentsTableBusy = true;
      AnnouncementsApi.getAnnouncments(this.pagemodelMain.currentPage, this.pagemodelMain.perPage)
        .then(result => {
          this.announcementsList = result.list
          this.pagemodelMain.totalRows = result.total;
          this.pagemodelMain.currentPage = result.page;
          this.pagemodelMain.perPage = result.pageSize;
          this.pagemodelMain.pageSize = result.pageSize;
        })
        .finally(() => {
        this.isAnnouncmentsTableBusy = false;
      })
    },

    typeToLabel(type) {
      if (type == null) {
        return '';
      }

      switch(type) {
        case 0: return i18n.t('parameters.promotion');
        case 1: return i18n.t('parameters.news');
        case 2: return i18n.t('parameters.highlight')
        default: return '';
      }
    },

    typeToColor(type) {
      switch(type) {
        case 0: return 'success';
        case 1: return 'info';
        case 2: return 'danger';
        default: return '';
      }
    },

    removeAnnouncement(announcement){
        Swal.fire({
          title: i18n.t('parameters.swal.removeAnnouncement.title'),
          html:announcement.title,
          icon: "info",
          showCancelButton: true,
          confirmButtonColor: "#f46a6a",
          cancelButtonColor: "#34c38f",
          cancelButtonText:  i18n.t('parameters.swal.removeAnnouncement.cancelButtonText'),
          confirmButtonText: i18n.t('parameters.swal.removeAnnouncement.confirmButtonText'),
      }).then(
        (result)=>{
          if(result.value){
            AnnouncementsApi.removeAnnouncement(announcement).then(
            (result)=>{
              if(result){
                this.getAnnouncments()
              }
            }
          )
          }
        }
      )
    },

    onAnnouncementImageUpload(event){
      this.selectedImage=event.target.files[0];
      this.uploadAnnouncementImage()
    },

    uploadAnnouncementImage(){
      const fd = new FormData();
      fd.append("file", this.selectedImage, this.selectedImage.name);
      if(!this.selectedAnnouncment || !this.selectedAnnouncment.id){
        return
      }
      AnnouncementsApi.uploadAnnouncementImage(fd,this.selectedAnnouncment.id).then((res) => {
        if (res) {
          this.imageModalUrl = "/api/image/get/" + res;
          this.getAnnouncments();
 
        }
      });

    }
  },
};


</script>

<template>
  <Layout>
    <!-- taille image  -->

    <input
      type="file"
      @change="onBannerUpload"
      ref="imageInput"
      style="display: none"
    />

    <input
      type="file"
      @change="onAnnouncementImageUpload"
      ref="announcementImageInput"
      style="display: none"
    />

    <div class="row p-4">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <h2 class="card-title font-size-25 pt-2 pb-4" style="font-size:2em;">{{$t('parameters.bigTitle')}} </h2>
              <b-tabs  nav-class="nav-tabs-custom" content-class="p-3 text-muted" active-nav-item-class="font-weight-bold text-uppercase ">
                  <b-tab v-if="isAdmin || hasBannersAccess" active class="border-0"  lazy @click="activeTab=0">
                    <template v-slot:title>
                        <span class="d-inline-block d-sm-none">
                        <i class="fas fa-shopping-cart font-size-16 pr-2"/>
                        </span>
                        <i class="d-none d-sm-inline-block fab fa-adversal  font-size-16 pr-2"/><span class="d-none d-sm-inline-block font-size-16">{{$t('parameters.bannerTitle')}} </span>
                    </template>
                
                    <div class="row pt-2">
                      <div class="col-sm-12 pr-2">
                        
                        <!-- button ajouter-->
                        <div class="row pb-4 mt-4">             
                          <div class="col-xl-3 col-lg-3 col-md-3 col-sm-12 col-xs-12">
                              <b-button variant="light" @click="showAllBanner = true">
                                  <i class=" text-primary fas fa-images font-size-16 font-weight-bold align-middle mr-2 "></i> 
                                  <span class=" text-primary text-uppercase font-weight-bold">
                                      {{$t('parameters.hover.arrows')}}
                                  </span>
                              </b-button>
                          </div>
                          <div class="col-xl-6 col-lg-6 col-md-6 "></div>
                          <div class="col-xl-3 col-lg-3 col-md-3 col-sm-12 col-xs-12 ">
                              <b-button variant="light" @click="$refs.imageInput.click()" class="float-sm-right mt-2 mt-lg-0 mt-xl-0 mt-md-0 " :disabled="uploadingBannerStarting">
                                  <b-spinner small :class="uploadingBannerStarting ? '' : 'd-none'"></b-spinner>
                                  <i class=" text-primary fas fa-plus-square font-size-16 font-weight-bold align-middle mr-2 "></i> 
                                  <span class=" text-primary text-uppercase font-weight-bold">
                                      {{$t('parameters.addBanner')}}
                                  </span>
                              </b-button>
                          </div>
                        </div>

                        <!-- table -->
                        <div class="table-responsive mb-0" >
                          <table class="table table-centered " >
                            <thead class="thead-light">
                              <tr>
                                <th class="text-left">{{$t('parameters.dateAdd')}} </th>
                                <th class="text-left">{{$t('parameters.image')}}</th>
                                <th class="text-left" style="width:9.375em">{{$t('parameters.position')}}</th>
                                <th class="text-right"></th>
                                <th class="text-center"></th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="data in bannerList" :key="data.id">
                                <td>
                                  <span  class="font-size-14 font-weight-bold ">{{data.creationDateStr}} </span>
                                </td>
                                <td class="text-left font-weight-bold font-size-14">
                                  {{ data.name }}
                                </td>
                                <td class="text-left">
                                    <div class="input-group input-group-sm pull-right mb-0"  >
                                      <b-form-input v-model="data.position" type="number" name="number" size="sm" class="no-shadow p-1" @keyup.native.enter="savePosition(data)"></b-form-input>
                                          <div class="input-group-append"  size="sm" >
                                            <b-button variant="link"  size="sm" class="input-group-text text-dark" @click="savePosition(data)" ><i  class="fas fa-save font-size-14"></i></b-button>
                                          </div>
                                      </div>
                                </td>
                                <td class="text-right">
                                  <i @click="imageModalUrl= '/api/image/get/' + data.generatedName;showBannerImageModal = true;isLinkImage=false"  style="cursor: pointer;" class="far fa-eye text-info" />
                                </td>
                                <td class="text-center ">
                                  <a  href="javascript:void(0);" @click="removeBanner(data)" :class="data.id ? '' : 'd-none'" class="action-icon text-danger ">
                                    <i  class="mdi mdi-trash-can font-size-22 "></i>
                                  </a>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                          <div v-if="isBannerTableBusy" class="d-flex justify-content-center">
                                <div class="spinner-border text-success" role="status">
                                          <span class=" sr-only">Chargement...</span>
                                </div>
                          </div>
                          <span v-if="!isBannerTableBusy && !bannerList.length" class="d-flex justify-content-center m-4 text-danger" >{{$t('parameters.tableBannerEmpty')}} </span>
                        </div>
                      </div>
                    </div>
                  </b-tab>
                  <b-tab v-if="isAdmin || hasAnnouncementsAccess" @click="activeTab=1;getAnnouncments()"  >
                  <template v-slot:title>
                      <span class="d-inline-block d-sm-none">
                      <i class="fas fa-sticky-note font-size-16"></i>
                      </span>
                      <i class="d-none d-sm-inline-block fas fa-bullhorn  font-size-16 pr-2"/><span class="d-none d-sm-inline-block font-size-16">{{$t('parameters.newsTitle')}}</span>
                  </template>
                  <div class="col-sm-12 pr-2">

            
              <!-- button ajouter -->
              <div class="row mb-4 mt-4">
                <div class="col-sm-8"></div>
                <div class="col-sm-4 ">
                    <b-button variant="light" @click="showAnnouncementsModal=true;formError=false;clearAnnounccement()" class="float-right">
                        <i class=" text-primary fas fa-plus-square font-size-16 font-weight-bold align-middle mr-2 text-uppercase "></i> 
                        <span class=" text-primary text-uppercase font-weight-bold">
                            {{$t('parameters.addNews')}}
                        </span>
                    </b-button>
                </div>
              </div>

              <!-- table -->
              <div class="row ">
                <div class="table-responsive mb-0">
                  <table class="table table-centered table-sm table-striped">
                    <thead class="">
                      <tr>
                        <th class="text-left" style="min-width:150px">{{$t('parameters.title')}}</th>
                        <th class="text-left">{{$t('parameters.date')}}</th>
                        <th class="text-left">{{$t('parameters.image')}}</th>
                        <th class="text-left">{{$t('parameters.type')}}</th>
                        <th class="text-left">{{$t('parameters.tag')}}</th>
                        <th class="text-right"></th>
                        <th class="text-center"></th>
                      </tr>
                    </thead>

                    <tbody>
                      <tr v-for="(announcement) in this.announcementsList" :key="announcement.id" >
                        <td>
                          {{announcement.title}}
                        </td>
                        <td>
                          <span
                            class="font-size-14 font-weight-bold "
                            >{{announcement.date}}
                          </span>
                        </td>
                        <td class="text-left font-weight-bold font-size-14">
                          <i
                            @click="
                              showBannerImageModal = true;
                              isLinkImage=true;
                              imageModalUrl='/api/image/get/' + announcement.image;
                              selectedAnnouncment=announcement"
                              
                            style="cursor: pointer;text-decoration: underline"
                            class="text-primary font-weight-bold "
                          >{{announcement.imageName}}</i>
                          
                        </td>
                        <td>
                          
                          <h5><b-badge href="#" :variant="typeToColor(announcement.type)">{{typeToLabel(announcement.type)}}</b-badge></h5>
                        </td>
                        <td>{{announcement.tag}}</td>
                        <td class="text-right">
                          <i
                            @click="
                              editAnnouncement(announcement);formError=false;showAnnouncementsModal = true;
                            "
                            :title="$t('parameters.hover.edit')"
                            style="cursor: pointer"
                            class="fas fa-edit text-warning font-size-16"
                          />
                        </td>

                        <td class="text-center ">
                          <a
                            data-v-a99d208c=""
                            :title="$t('parameters.hover.delete')"
                            href="javascript:void(0);"
                            @click="removeAnnouncement(announcement)"
                            class="action-icon text-danger"
                          >
                            <i
                              data-v-a99d208c=""
                              class="mdi mdi-trash-can font-size-22"
                            ></i>
                          </a>
                        </td>
                      </tr>

                    </tbody>
                  </table>
                  <div v-if="isAnnouncmentsTableBusy" class="d-flex justify-content-center">
                    <div class="spinner-border text-success" role="status">
                      <span class=" sr-only">Loading...</span>
                    </div>
                  </div>
                  <span v-if="!isAnnouncmentsTableBusy & !announcementsList.length" class="d-flex justify-content-center m-4 text-danger" >{{$t('parameters.tableNewsEmpty')}} </span>
                
                </div>
              </div>
              <!-- Pagination -->
                      <div class="row pt-3 mb-sm-4">
                          <div class="col-sm-8">
                              <div class="dataTables_paginate paging_simple_numbers float-left d-none d-md-flex">
                                  <b-form-select @input="getAnnouncments()"  v-model="pagemodelMain.perPage" size="sm" style="width: 60px" :options="[10,15,50,100]"></b-form-select>
                                  <div class="d-none d-lg-inline pt-1"><span class="text-muted mb-0 ml-1">{{$t('pagination.from')}}</span><span class="font-weight-bold"> {{pagemodelMain.totalRows}} {{$t('pagination.lines')}}</span></div>
                              </div>
                          </div>
                          <div class="col-sm-4">
                              <div class="dataTables_paginate paging_simple_numbers float-right">
                                  <ul class="pagination pagination-rounded mb-0">
                                  <b-pagination v-model="pagemodelMain.currentPage" :per-page="pagemodelMain.pageSize" :total-rows="pagemodelMain.totalRows" @input="getAnnouncments()" :disabled="isAnnouncmentsTableBusy" ></b-pagination>
                                  </ul>
                              </div>
                          </div>
                      </div> 
                      <!-- Fin Pagination  -->
                </div>
                  </b-tab>
                
              </b-tabs>

              <b-alert show variant="warning" class="text-justify mb-4">
                  <i class="mdi mdi-alert-outline mr-2"></i>{{$t('parameters.imageSize')}}
                  <span class="font-weight-bold"> {{ this.maxFileSize }} </span
                  >. {{$t('parameters.imageType')}}
                  <span class="font-weight-bold"> PNG </span>,
                  <span class="font-weight-bold">JPG </span>,
                  <span class="font-weight-bold"> BMP</span>, {{$t('parameters.and')}}
                  <span class="font-weight-bold">GIF</span>.
                  <span v-if="activeTab==0">{{$t('parameters.dimensions')}}<span class="font-weight-bold"> {{dimensions[0]["width"]}} X {{dimensions[0]["height"]}} px </span> .</span>
                  <span v-if="activeTab==1">{{$t('parameters.imagesDimensions')}}<span class="font-weight-bold"> {{imageDimensions[0]["width"]}} X {{imageDimensions[0]["height"]}} px </span> .</span>
              </b-alert>

          </div>
        </div>
      </div>
    </div>

      
    <!-- </div> -->

    <b-modal
      v-model="showBannerImageModal"
      :title="!isLinkImage ? $t('parameters.modal.modalBannerTitle'):$t('parameters.modal.modalNewsTitle')"
      centered
      :hide-footer="!isLinkImage"
      title-class="text-primary"
      title-tag="h5"
      header-close-variant="danger"
      :size="!isLinkImage? 'xl' : 'l'"
    >
      <div class="row p-2">
        <img v-bind:src="imageModalUrl" alt style="width: 100%; height: 100%" />
      </div>
       <template v-if="isLinkImage" v-slot:modal-footer>
          <b-button  variant="warning" @click="$refs.announcementImageInput.click()" size="md" ><span class="text-primary font-weight-bold">Modifier</span></b-button>
        </template>
      
    </b-modal>

    <b-modal
      v-model="showAllBanner"
      :title=" $t('parameters.modal.modalAllBannerTitle')"
      hide-footer
      centered
      title-class="text-primary"
      title-tag="h5"
      header-close-variant="danger"
      size="xl"
    >
      <div style="background-color: #2a323c">
          <b-carousel
                style="text-shadow: 0px 0px 2px #000"
                img-width="1597"
                img-height="279"
                :interval="4000"
                indicators
                controls
              >
                <div v-for="banner in bannerList" :key="banner.id" >
                  <b-carousel-slide v-if="!isBannerTableBusy"
                    :img-src="'/api/banner/get/' + banner.generatedName"
                  ></b-carousel-slide>
                </div>
            </b-carousel>
      </div>
    </b-modal>

    <b-modal 
       v-model="showAnnouncementsModal"  
      :title= "!selectedAnnouncment.id ? $t('parameters.addNews')  : $t('parameters.modal.modalEditNewsTitle')"
      centered  
      title-tag="h5"
      header-close-variant="danger"
      title-class="text-primary"
      size="xl">
      <div >


        <div class="form-group row mb-3 ml-4">
          <label class="col-md-3 col-form-label font-size-14" >{{$t('parameters.title')}}<span class="text-danger ml-2" style="font-size: 0.6rem;">({{$t('parameters.mandatory')}})</span></label>
          <div class="col-md-9">
            <input v-model="selectedAnnouncment.title" type="text"  class="form-control" :placeholder="$t('parameters.titlePlaceHolderFR')" />
          </div>
        </div>

        <div class="form-group row mb-3 ml-4">
          <label class="col-md-3 col-form-label " ></label>
          <div class="col-md-9">
            <input v-model="selectedAnnouncment.titleEn" type="text"  class="form-control" :placeholder="$t('parameters.titlePlaceHolderEN')"  />
          </div>
        </div>

        <div class="form-group row mb-3 ml-4">
          <label class="col-md-3 col-form-label font-size-14" >{{$t('parameters.date')}}<span class="text-danger ml-2" style="font-size: 0.6rem;">({{$t('parameters.mandatory')}})</span></label>
            <div class="col-md-9">
              <b-form-datepicker
                v-model="selectedAnnouncment.date"
                right
                locale="fr"
                label-no-date-selected="Date"
                dark
              ></b-form-datepicker>
            </div>
        </div>

        <div  class="form-group row mb-3 ml-4">
          <label class="col-md-3 col-form-label font-size-14" for="name">{{$t('parameters.type')}}<span class="text-danger ml-2" style="font-size: 0.6rem;">({{$t('parameters.mandatory')}})</span></label>
          <div class="col-md-9">
            <v-select  class="style-vselect font-size-16" v-model="selectedType" :options="[{name:$t('parameters.promotion'), value: 0 }, {name:$t('parameters.news'), value: 1},{name:$t('parameters.highlight'), value: 2}]"  :placeholder="$t('parameters.listNews')" label="name">
              <span slot="no-options">{{$t('lists.emptyLists.label')}}</span>
            </v-select> 
          </div>
        </div>

        <div class="form-group row mb-3 ml-4">
          <label class="col-md-3 col-form-label font-size-14" >{{$t('parameters.tag')}}</label>
          <div class="col-md-9">
            <input v-model="selectedAnnouncment.tag" type="text"  class="form-control" :placeholder="$t('parameters.tagPlaceHolderFR')"   />
          </div>
        </div> 

        <div class="form-group row mb-3 ml-4">
          <label class="col-md-3 col-form-label " ></label>
          <div class="col-md-9">
            <input v-model="selectedAnnouncment.tagEn" type="text"  class="form-control" :placeholder="$t('parameters.tagPlaceHolderEN')"  />
          </div>
        </div> 

        <div class="form-group row mb-3 ml-4">
          <label class="col-md-3 col-form-label font-size-14"
           >{{$t('parameters.descriptionFR')}}
          </label>
          <div class="col-md-9">
            <ckeditor v-model="selectedAnnouncment.description" :editor="editor" ></ckeditor>
          </div>
       </div>

        <div class="form-group row mb-3 ml-4">
          <label class="col-md-3 col-form-label font-size-14">
            {{$t('parameters.descriptionEN')}}
          </label>
          <div class="col-md-9">
            <ckeditor v-model="selectedAnnouncment.descriptionEn" :editor="editor" ></ckeditor>
          </div>
       </div>


        <div v-if="!selectedAnnouncment.id" class="form-group row mb-3 ml-4">
          <label class="col-md-3 col-form-label font-size-14" >{{$t('parameters.image')}}<span class="text-danger ml-2" style="font-size: 0.6rem;">({{$t('parameters.mandatory')}})</span></label>
          <div class="col-md-9">
            <vue-dropzone
              id="dropzone"
              ref="myVueDropzone"
              maxFileSizeInMB="1"
              maxNumberOfFiles="1"
              :use-custom-slot="true"
              :options="dropzoneOptions"
            >
              <div class="dropzone-custom-content">
                <i class="display-4 text-muted bx bxs-cloud-upload"></i>
                <h4>{{$t('parameters.dropImage')}}</h4>
              </div>
            </vue-dropzone>
          </div>
        </div>

        <div  v-if="formError" class="row mb-3 ml-4">
          <div class="col-md-3"/>
          <div class="col-md-9">
            <span  class="text-danger font-size-10 font-italic" >{{$t('parameters.alert')}} </span> 
          </div>
        </div>

      </div>
        <template v-slot:modal-footer>
          <b-button variant="secondary" @click="showAnnouncementsModal = false" size="md">{{$t('buttons.cancel')}}</b-button>
          <b-button  variant="warning" @click="saveAnnouncment()" size="md" :disabled="saveAnouncementStarting" >
            <b-spinner small :class="saveAnouncementStarting ? '' : 'd-none'"></b-spinner>
            <span class="text-primary font-weight-bold">{{$t('buttons.save')}}</span>
            </b-button>
        </template>
      </b-modal> 

  </Layout>
</template>

